<template>
    <v-dialog v-model="toggle.dateMenu" width="640">
        <template v-slot:activator="{ on }">
            <v-btn color="grey lighten-2" v-on="on">
                {{ buttonText }}
            </v-btn>
        </template>
        <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
                {{ dialogTitle }}
            </v-card-title>
            <v-card-text>
                <date-range-picker style="justify-content: center; display: flex;" v-model="validityPeriod"></date-range-picker>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="buttonCLicked_ok">
                    {{ dialogButtonText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

    import DateRangePicker from '@/components/DateRangePicker.vue'

    export default {
        components: {
            'date-range-picker': DateRangePicker
        },
        props: {
            buttonText: {
                type: String,
                default: 'Open'
            },
            dialogTitle: {
                type: String,
                default: 'Period'
            },
            dialogButtonText: {
                type: String,
                default: 'OK'
            }
        },
        data () {
            return {
                validityPeriod: {
                    startDate: null,
                    endDate: null
                },                
                toggle: {
                    dateMenu: false
                }
            }
        },
        computed: {
            validity () 
            {
                return (this.validityPeriod.startDate && this.validityPeriod.endDate) ? `${this.validityPeriod.startDate} to ${this.validityPeriod.endDate}` : ''
            },
        },
        methods: {
            handleStartDateInput () 
            {
                this.toggle.startDate = false
                if (!this.validityPeriod.endDate) {
                    this.validityPeriod.endDate = this.validityPeriod.startDate
                    this.toggle.endDate = true
                }
            },
            buttonCLicked_ok ()
            {
                this.$emit('selected', this.validityPeriod)
                this.toggle.dateMenu = false
            }
        }
    }
</script>
